import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output, signal, ViewChild, inject } from '@angular/core';
import { EmblaCarouselType } from 'embla-carousel';
import { SliderComponent } from '../../../slider/slider.component';
import { MediaImage } from '../../../_shared/models/media/media-image.model';
import { IMediaItem } from '../../../_shared/models/media/media-item.model';
import { MediaCollectionService } from '../media-collection.service';
import { ImageData } from '../../../_shared/models/image/image-data.model';
import { ImageDataDb } from '../../../_shared/data/image-data-db.data';
import { ImageItemComponent } from '../../media-item/image-item/image-item.component';
import { PlayButtonComponent } from '../../../button/play-button/play-button.component';


@Component({
    selector: 'sirius-media-slider-thumbnails',
    templateUrl: './media-slider-thumbnails.component.html',
    styleUrls: ['./media-slider-thumbnails.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SliderComponent, ImageItemComponent, PlayButtonComponent]
})
export class MediaSliderThumbnailsComponent implements OnInit {
    private _mediaCollectionService = inject(MediaCollectionService);

    @Input() items: IMediaItem[] = [];
    @Input() imageData: (ImageData | undefined)[] = [];

    @Output() clickEvent = new EventEmitter<number>();
    @Output() selectedIndex = new EventEmitter<number>();
    @Output() scrollNextEvent = new EventEmitter<void>();
    @Output() scrollPreviousEvent = new EventEmitter<void>();

    @ViewChild(SliderComponent) slider!: SliderComponent;

    thumbnails: MediaImage[] = [];
    hoveredIndex = signal<number | null>(null);

    @HostBinding('class.sir-two')
    get isSizeTwo() {
        return this.items.length <= 2;
    }

    @HostBinding('class.sir-three')
    get isSizeThree() {
        return this.items.length === 3;
    }

    @HostBinding('class.sir-fourPlus')
    get isSizeFourPlus() {
        return this.items.length > 3;
    }

    get carousel(): EmblaCarouselType | undefined {
        return this.slider?.carousel;
    }

    ngOnInit(): void {
        this.imageData = [
            ImageDataDb.media.slider.small.two,
            ImageDataDb.media.slider.small.three,
            ImageDataDb.media.slider.small.fourPlus,
        ];

        this.thumbnails = this._mediaCollectionService.createThumbnails(this.items);

        return;
    }

    getThumbnailImageData(): ImageData | undefined {
        let count = Math.max(this.thumbnails.length, 2);
        count = Math.min(count, 4) - 1;

        return this.imageData[count - 1];
    }

    setIndex(index: number): void {
        this.selectedIndex.emit(index);
    }

    onClick(index: number): void {
        // if (!this.carousel?.clickAllowed()) return;

        this.clickEvent.emit(index);
    }

    onMouseEnter(index: number): void {
        this.hoveredIndex.set(index);
    }

    onMouseLeave(): void {
        this.hoveredIndex.set(null);
    }
}
